import { Building2, Wind, Zap, Wrench, Flame, Settings, ClipboardList } from "lucide-react";

export const SERVICE_ICONS = { Building2, Wind, Zap, Wrench, Flame, Settings, ClipboardList };
